var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.89978,
    y: 4.39862,
    width: 18.5835,
    height: 26.5479,
    rx: 4.31403,
    fill: "#423948",
    stroke: "white",
    strokeWidth: 1.99109
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.88196,
    y: 1.08014,
    width: 18.5835,
    height: 26.5479,
    rx: 4.31403,
    fill: "#423948",
    stroke: "white",
    strokeWidth: 1.99109
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.4e05dea7230252e5703580f384bfafd5.svg";
export { ForwardRef as ReactComponent };